(() => {
  'use strict';
  document.body.classList.add('has-js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const header = document.querySelector('.mk-header');
  const menu = document.querySelector('.mk-menu');
  const menuButton = document.querySelector('.mk-menu-button');
  menuButton.addEventListener('click', () => { menu.showModal(); document.body.classList.add('menu-open'); });
  menu.querySelector('.mk-menu-close').addEventListener('click', () => menu.close());
  menu.addEventListener('close', () => document.body.classList.remove('menu-open'));
  menu.addEventListener('click', event => {
    if (event.target.closest('a')) menu.close();
    if (event.target === menu) {
      const box = menu.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right) menu.close();
    }
  });
  const top = document.querySelector('.back-to-top');
  let scrollTween;
  const g = window.gsap;
  const ST = window.ScrollTrigger;
  if (g && window.ScrollToPlugin) g.registerPlugin(window.ScrollToPlugin);
  if (top) {
    document.body.classList.add('has-top-control');
    let ticking = false;
    const photoAreas = [...document.querySelectorAll('.mk-hero,.mk-work-photo-window,.mk-discover')];
    const updateTop = () => {
      top.classList.toggle('is-visible', scrollY > 320);
      header.classList.toggle('is-scrolled', scrollY > 70);
      const edge = header.offsetHeight / 2;
      header.classList.toggle('is-over-photo', photoAreas.some(el => { const r=el.getBoundingClientRect(); return r.top<=edge && r.bottom>edge && r.left<=1 && r.right>=innerWidth-1; }));
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(updateTop); ticking = true; } }, { passive: true });
    updateTop();
    addEventListener('resize', updateTop, { passive: true });
    top.addEventListener('click', event => {
      event.preventDefault(); scrollTween?.kill();
      const done = () => { document.getElementById('top').focus({ preventScroll: true }); history.replaceState(null, '', '#top'); };
      if (reduce.matches || !g || !window.ScrollToPlugin) { window.scrollTo({ top: 0, behavior: reduce.matches ? 'instant' : 'smooth' }); done(); return; }
      const old = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      const restore = () => { document.documentElement.style.scrollBehavior = old; };
      scrollTween = g.to(window, { duration: Math.min(1.25, .55 + scrollY / 6500), ease: 'power3.inOut', scrollTo: { y: 0, autoKill: true, onAutoKill: restore }, onComplete: () => { restore(); done(); }, onInterrupt: restore });
    });
    reduce.addEventListener('change', () => scrollTween?.kill());
  }

  const track = document.querySelector('.mk-gallery-track');
  const prev = document.querySelector('.mk-gallery-prev');
  const next = document.querySelector('.mk-gallery-next');
  const position = document.querySelector('.mk-gallery-position');
  if (track && prev && next) {
    const stride = () => track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
    const controls = () => {
      const count = track.children.length;
      const index = Math.min(count, Math.max(1, Math.round(track.scrollLeft / stride()) + 1));
      prev.disabled = track.scrollLeft < 3;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
      position.textContent = `${String(index).padStart(2, '0')} / ${String(count).padStart(2, '0')}`;
    };
    const step = dir => track.scrollBy({ left: dir * stride(), behavior: reduce.matches ? 'instant' : 'smooth' });
    prev.addEventListener('click', () => step(-1)); next.addEventListener('click', () => step(1));
    track.addEventListener('keydown', event => { if (event.target !== track) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1); } });
    track.addEventListener('scroll', controls, { passive: true });
    new ResizeObserver(controls).observe(track); controls();
  }

  // Everything remains readable when either animation library is unavailable.
  if (!g || !ST) return;
  g.registerPlugin(ST);
  const workshopPhoto = document.querySelector('.mk-work-photo-window');
  const media = g.matchMedia();
  media.add({ motion: '(prefers-reduced-motion: no-preference)', small: '(max-width:600px)' }, context => {
    if (!context.conditions.motion) return;
    const small = context.conditions.small;
    if (scrollY < innerHeight) {
      const opening=g.timeline({ paused:!!window.RGCEntry, defaults: { ease: 'power3.out' } })
        .from('.mk-hero-image', { scale: 1.045, duration: 2.4, clearProps: 'transform' }, 0)
        .from('.mk-hero-title>*', { opacity: 0, y: 18, duration: 1.3, stagger: .18, clearProps: 'opacity,transform' }, .15)
        .from('.mk-scroll-link,.mk-hero-caption', { opacity: 0, duration: 1, clearProps: 'opacity' }, .85);
      window.RGCEntry?.ready.then(()=>opening.play(0));
    }
    document.querySelectorAll('[data-reveal]').forEach(el => {
      g.from(el, { y: small ? 18 : 28, opacity: 0, duration: .95, ease: 'power2.out', clearProps: 'opacity,transform', scrollTrigger: { trigger: el, start: 'top 93%', once: true } });
    });

    if (workshopPhoto) {
      g.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: { id: 'maker-workshop-expand', trigger: workshopPhoto, start: 'top 90%', end: 'top 32%', scrub: .4, invalidateOnRefresh: true }
      })
        .fromTo(workshopPhoto, { clipPath: () => `inset(0px ${small ? 22 : Math.min(innerWidth * .14, 200)}px)` }, { clipPath: 'inset(0px 0px)', duration: 1 }, 0)
        .fromTo(workshopPhoto.querySelector('img'), { scale: 1.06 }, { scale: 1, duration: 1 }, 0);
    }
  });
  const refresh = () => ST.refresh();
  if (document.readyState === 'complete') refresh(); else addEventListener('load', refresh, { once: true });
  document.fonts?.ready.then(refresh);
  document.querySelector('.mk-more-history')?.addEventListener('toggle', refresh);
})();
